export interface RoleOption {
    label: string;
    value: string;
}

export const TEAM_USER_ROLES: Record<string, string> = {
    owner: 'Owner',
    admin: 'Administrator',
    manager: 'Manager',
    service: 'Service',
    mh_supervisor: 'Supervisor',
    mh_service_rep: 'Service Representative',
    billing: 'Accounting',
    member: 'Member',
    none: 'None',
};

export const GROUP_USER_ROLES: Readonly<Record<string, string>> = Object.freeze({
    agent: 'Agent',
    blast: 'Blast',
    marketer: 'Marketer',
    admin: 'Administrator',
});

export const ORG_UNIT_USER_ROLES = GROUP_USER_ROLES;

export const DEFAULT_GROUP_ROLE = 'agent';
export const DEFAULT_ORG_UNIT_ROLE = DEFAULT_GROUP_ROLE;

const buildRoleOptions = (roles: Record<string, string>, exclude: string[]): RoleOption[] =>
    Object.entries(roles)
        .filter(([key]) => !exclude.includes(key))
        .map(([key, label]) => ({ label, value: key }));

export const teamRolesOptions = ({ exclude = [] }: { exclude?: string[] }): RoleOption[] =>
    buildRoleOptions(TEAM_USER_ROLES, exclude);

export const groupRolesOptions = ({ exclude = [] }: { exclude?: string[] } = {}): RoleOption[] =>
    buildRoleOptions(GROUP_USER_ROLES, exclude);

export const orgUnitRolesOptions = ({ exclude = [] }: { exclude?: string[] } = {}): RoleOption[] =>
    buildRoleOptions(ORG_UNIT_USER_ROLES, exclude);
